import './LearningModuleHeader.scss';
import '../../HeaderCommon.scss';
import { IconButton, Skeleton } from '@mui/material';
import { ReactComponent as ChevronLeft } from 'images/icons/ChevronLeftThin.svg';
import SectionTitle from 'components/TextComps/SectionTitle';
import { useNavigate } from 'react-router-dom';

type LearningModuleHeaderProps = {
  title: string | undefined;
  shortDescription: string | undefined;
  navigationPath: string;
  progress?: number;
  isPending: boolean;
};

export const LearningModuleHeader = ({ title, shortDescription, navigationPath, progress, isPending }: LearningModuleHeaderProps) => {
  const navigate = useNavigate();

  return (
    <header className='learning-hub-module-grid-container learning-module-header-wrapper'>
      {!isPending ? (
        <>
          <IconButton className='learning-hub-back-button' onClick={() => navigate(navigationPath)}>
            <ChevronLeft className='back-icon' />
          </IconButton>

          <div className='learning-hub-module-title'>
            <SectionTitle>
              <>{title}</>
            </SectionTitle>
          </div>
          <span className='learning-hub-short-description'>{shortDescription}</span>
          {progress && (
            <div className='progress-circle' style={{ '--progress': `${progress}%` } as React.CSSProperties}>
              <span className='progress-value'>{progress.toFixed(0)}%</span>
            </div>
          )}
        </>
      ) : (
        <div className='header-loader-wrapper'>
          <Skeleton variant='text' width={200} sx={{ marginLeft: '1.5rem' }} />
          <Skeleton variant='text' width={450} sx={{ marginLeft: '1.5rem' }} />
        </div>
      )}
    </header>
  );
};
